/**
 * `cn` — className merge helper (ShadCN/ui convention).
 *
 * Combines `clsx` (conditional class composition) with `tailwind-merge`
 * (dedupes/overrides conflicting Tailwind utility classes so the *last*
 * matching class wins). Standard helper every generated ShadCN/ui
 * primitive (`src/components/ui/*.tsx`) is built against — see
 * https://ui.shadcn.com/docs/installation/manual.
 *
 * Mirrors `src/lib/utils.ts` (root `src/` tree) added for issue #170;
 * this is the `apps/web`-native copy — `apps/web` is its own workspace
 * package (see `apps/web/tsconfig.json`'s `@/*` -> `./src/*` alias) and
 * cannot import across to root `src/` at runtime, so each tree owns its
 * own copy of this small, dependency-free helper rather than sharing one
 * module across package boundaries.
 *
 * Added for "Unified API client with RTK Query for all frontend data
 * fetching" — the first `apps/web` component to use a ShadCN/ui
 * primitive (`components/ui/skeleton.tsx`) for API loading states.
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
